<template>
    <div calss="eda-addon">

        <eda-list
                :heading="$t('accessoriesList.heading')"
                :items="items"

        ></eda-list>


        <div class="eda-addon__complete">
            <eda-button
                    :loading="request.loading"
                    :error="request.error"
                    @click="submit"
                    :label="$t('accessoriesList.submit')">
            </eda-button>
        </div>

    </div>
</template>

<script>

  import EdaList from "../components/vList"
  import EdaButton from "../components/vButton"
  import axios from "axios"
  import apiMixin from "../mixins/apiMixin.js"
  import transformers from "../transformers/transformers"
  import { mapActions } from "vuex"
  import { mapGetters } from "vuex"
  import _ from "lodash"

  export default {
    name: "eda-addon-products",
    mixins: [
      apiMixin.apiMixin,
      transformers.addonCardTransformer,
      transformers.orderToPost,
    ],
    props: {
      orderId: { type: String, default: "" }
    },
    data: function () {
      return {
        request: {
          loading: false,
          error: false,
          success: false
        },
        loaded: false
      }
    },
    computed: {
      ...mapGetters([
        'getCurrentSolution',
        'getCustomer',
        'getOrderState'
      ]),
      items() {
        let connector = this.getCustomer.carModel.connector.toLowerCase();
        let raw = this.getCurrentSolution.addonProducts[connector];
        let transformed = [];

        for (let key in raw) {
          transformed.push(this.transformItem(raw[key]));
        }


        return transformed
      }

    },
    components: {
      EdaList,
      EdaButton
    },


    methods: {

      ...mapActions(['setSolution', 'addAddon', 'removeAddon', 'clearOrderState']),

      submit() {
        this.$router.push("/orders/new");
      },

      hasAddon(id) {
        let solution = this.getOrderState;
        for (let key in solution.addonProducts) {
          if (solution.addonProducts[key].id == id) {
            return true;
          }
        }
        return false;
      },

      toggleAddon(addon) {
        if (this.hasAddon(addon.id)) {
          this.removeAddon(addon.id)
          return false;
        } else {
          this.addAddon(addon)
          return true;
        }
      },

      transformItem(item) {
        var that = this;
        var trafo = this.addonCardTransform(item);
        trafo.type = "toggle";
        trafo.selected = that.hasAddon(trafo.id);

        trafo.onClick = function () {
          that.toggleAddon({ ...item, quantity: 1 });
        }


        return trafo;
      }
    },

    mounted: function () {

      // removing previously selected addons that are not available for current solution
      let orderAddOns = this.getOrderState.addonProducts;
      for (let key in orderAddOns) {
        let addOn = orderAddOns[key]
        if (!this.items.find(i => i.id === addOn.id)) {
          this.removeAddon(addOn.id);
        }
      }


      /*        var that = this;
      let headers = this.apiHeaders;
      let id = this.getCurrentSolution.id;

     axios.get("/api/solutions/" + id, headers).then(function (response) {
          var response = response.data.data.addonProducts;
          for (var index in response) {
              that.items.push(that.transformItem(response[index]))
          }
          that.loaded = true;
      }).catch(function (error) {
          console.log(error);
      });
      */
    }
  }


</script>


<style>

    .eda-addon__complete {
        width: 100%;
        display: flex;
        padding-top: 3em;
        justify-content: center;
    }


</style>